import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-generic-confirm-dialog',
  imports: [TranslatePipe,CommonModule],
  templateUrl: './generic-confirm-dialog.html',
  styleUrl: './generic-confirm-dialog.scss',
})
export class GenericConfirmDialog {
  firstmsg = '';
  secondmsg = '';
  showModal = true;
  isCanceldAllowed: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<GenericConfirmDialog>) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.firstmsg = this.data.firstmsg;
    this.secondmsg = this.data.secondmsg;
    this.isCanceldAllowed = this.data.isCanceldAllowed === undefined ? false : this.data.isCanceldAllowed;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.onNoClick();
    this.data.parent.confirm(this.data.func);
  }

  cancel(): void {
    this.onNoClick();
  }
}
